import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

import tokens from '../../design/tokens'

const Content = styled.div`
  flex-grow: 0;
  width: ${props => props.width};
  ${props =>
    props.before &&
    css`
      margin-right: ${tokens.grid.gutterN}px;
      text-align: left;
    `}
  ${props =>
    props.after &&
    css`
      margin-left: ${tokens.grid.gutterN * 2}px;
      text-align: right;
    `}
`

export const DataListExtraColumn = ({
  className,
  children,
  before,
  after,
  width,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <Content
      className={className}
      before={before}
      after={after}
      width={width}
      data-mu-test={dataAttributeTest}
    >
      {children}
    </Content>
  )
}

DataListExtraColumn.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  before: PropTypes.bool,
  after: PropTypes.bool,
  width: PropTypes.string,
  'data-mu-test': PropTypes.string
}
